export const messages = {
  en: {
    advertVedioView: {
      machineCodeRequired: 'Machine code is required',
      communityIdRequired: 'Community ID is required',
      loadFailed: 'Failed to load advertisement data'
    }
  },
  zh: {
    advertVedioView: {
      machineCodeRequired: '请求参数中未包含设备编码',
      communityIdRequired: '请求参数中未包含小区信息',
      loadFailed: '加载广告数据失败'
    }
  }
}